import { toast } from "react-toastify";
import { apiURL } from "../config";

export async function uploadTempFile(axiosPrivate, file) {
	const formData = new FormData();
	formData.append("temp_file[file]", file);

	return axiosPrivate
		.post(`${apiURL}/temp-file/upload.json`, formData, {
			headers: {
			"Content-Type": "multipart/form-data",
		},
		})
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				console.log("📎 Temp file uploaded successfully:", res.data);
				return res.data; // Returns the TempFile object with ID and file info
			} else {
				throw new Error("Failed to upload temporary file");
			}
		})
		.catch((err) => {
			console.error("❌ Temp file upload error:", err);
			toast.error("Could not upload file. Please try again.");
			throw err;
		});
}

export async function removeTempFile(axiosPrivate, tempFileId) {
	return axiosPrivate
		.delete(`${apiURL}/temp-file/${tempFileId}.json`)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				console.log("🗑️ Temp file removed successfully");
				return res;
			} else {
				throw new Error("Failed to remove temporary file");
			}
		})
		.catch((err) => {
			console.error("❌ Temp file removal error:", err);
			throw err;
		});
}